import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Results from './pages/Results';
import CarDetails from './pages/CarDetails';
import AboutUsPage from './pages/AboutUsPage';
import FAQsPage from './pages/FaqsPage';
import ContactUsPage from './pages/ContactUsPage';
import FranchisePage from './pages/FranchisePage';
import Checkout from './pages/Checkout';
import ConfirmationPage from './pages/ConfirmationPage';
import ManageBooking from './pages/ManageBooking';
import AdminDashboard from './pages/AdminDashboard';
import Testimonials from './pages/Testimonials';
import Fleet from './pages/Fleet';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUsPage />} />
        <Route path="/faqs" element={<FAQsPage />} />
        <Route path="/contact" element={<ContactUsPage />} />
        <Route path="/franchise" element={<FranchisePage />} />
        <Route path="/results" element={<Results />} />
        <Route path="/car/:id" element={<CarDetails />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/confirmation" element={<ConfirmationPage />} />
        <Route path="/managebooking" element={<ManageBooking />} />
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/fleet" element={<Fleet />} />
      </Routes>
    </Router>
  );
}

export default App;